
import React, { Fragment } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ArcaField } from '../../../code/ArcaField';
import { ArcaHttpClientEmail } from '../../../code/ArcaHttpClientEmail';
import { ArcaPageFieldState } from '../../../code/ArcaPageFieldState';
import { ArcaSecurity } from '../../../code/ArcaSecurity';
import { ArcaEmail } from '../../../code/Types/ArcaEmail';
import { ArcaComponent } from '../../pages/ArcaComponent';
import { ArcaLink } from '../Fields/ArcaLink';
import { InputFieldArray } from '../Fields/InputFieldArray';
import { StatusBar } from '../StatusBar';

export class EmailEditPanel extends ArcaComponent {

    constructor(props) {
        super(props);

        let email = this.props.email ?? new ArcaEmail()

        this.state = {
            formState: this.buildFields(email),
            email: email,
            disabled: true
        };
    }

    async componentDidMount() {
    }

    onConfirm() {
        let { formState } = this.state;

        var email = new ArcaEmail()
        email.Subject = formState.GetField('Subject').Value
        email.Body = formState.GetField('Body').Value
        email.PersonId = ArcaSecurity.IsAdmin ? this.props.personId : 0;

        ArcaHttpClientEmail.Send(
            email,
            (() => {
                this.setState({
                    disabled: true,
                    message: "Your email has been sent",
                    isError: false
                });
                this.props.emailSent()
            }),
            () => this.setState({
                disabled: false,
                message: "Your email was not sent",
                isError: true
            }))
    }

    render() {

        let { formState, isError, message, email, disabled } = this.state;
        let { personId, onCancel } = this.props;

        return (
            <Fragment>
                <Modal isOpen={true} toggle={onCancel} className="">
                    <ModalHeader>
                        {`Enter the details to send the message to ${ArcaSecurity.IsAdmin ? 'the customer' : ' Arca'} `}
                    </ModalHeader>
                    <ModalBody>
                        <StatusBar message={message} isError={isError} />
                        <InputFieldArray
                            formState={formState}
                            onUpdate={this.onUpdate.bind(this)}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <ArcaLink disabled={disabled} colour="primary" onClick={() => this.onConfirm()} text='Confirm' />
                        <ArcaLink colour="secondary" onClick={() => onCancel()} text='Cancel' />
                    </ModalFooter>
                </Modal>
            </Fragment>
        );
    }

    async onUpdate(value, isValid, fieldName) {

        let { formState } = this.state

        var field = formState.GetField(fieldName);
        field.IsValid = isValid;
        field.Value = value;

        if (!formState.IsValid)
            return false;

        this.setState({
            fieldState: formState,
            disabled: !formState.IsValid,
        });
    }

    buildFields(email) {
        var formState = new ArcaPageFieldState();

        formState.AddField(new ArcaField("Subject", "Subject", email.Subject, false, true, 'text', 'text'));
        formState.AddField(new ArcaField("Message", "Body", email.Body, false, true, 'textarea', 'freeform'));

        return formState;
    }
}